import { TextField } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledGeneralSectionContainer = styled.section`
  width: 100%;
`;

export const StyledBottomAdornment = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 0.6rem;
`;

export const StyledMinutesText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTimeToCompletetInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledTimeToCompleteInput = styled(TextField)`
  width: 7.5rem;
`;

export const StyledRoomCodeInput = styled(TextField)`
  && {
    :disabled {
      color: ${({ theme }) => theme.colors.grey[600]};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 12.6rem;
  }
`;
export const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.1rem;
`;
